import Icon from '../components/Icon.vue'

Icon.register({
  'toggle-on': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 256C576 362 490 448 384 448H192C86 448 0 362 0 256S86 64 192 64H384C490 64 576 150 576 256zM384 128C313.3 128 256 185.2 256 256 256 326.7 313.2 384 384 384 454.7 384 512 326.8 512 256 512 185.3 454.8 128 384 128'
      }
    ]
  }
})
